module.exports = __webpack_public_path__ + "static/img/p8.f2d12710.png";